import { Avatar, Chip, Grid } from "@mui/material";
import MaterialTable from "@material-table/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { green } from "@mui/material/colors";

import NavBar from "../../components/Navbar";
import { downloadInfo, getSecurityInfo } from "../../store/ducks/duckSecurity";
import DetailSecurity from "../../components/DetailSecurity";

const fileDownload = require("js-file-download");

export const SecurityMenuItem = () => {
  const data = useSelector((state) => state.security.dataSecurity);
  const loading = useSelector((state) => state.security.isLoading);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSecurityInfo());
  }, [dispatch]);

  return (
    <>
      <NavBar />
      <Grid
        container
        direction="column"
        justify="flex-start"
        spacing={0}
        style={{
          minHeight: "calc(100% - 64px)",
          paddingLeft: "10vw",
          paddingTop: 88,
          paddingRight: "10vw",
          maxWidth: "100vw",
        }}
      >
        <MaterialTable
          columns={[
            { title: "Menu Item", field: "menuItemName" },
            {
              title: "GroupsName",
              field: "groupsName",
              render: (rowData) => (
                <>
                  {rowData.groupsName.map((name, i) => (
                    <Chip
                      key={`chip-${name}-${i}`}
                      avatar={
                        <Avatar
                          style={{
                            color: green[700],
                            backgroundColor: green[300],
                          }}
                        >
                          {name.slice(0, 2)}
                        </Avatar>
                      }
                      color="primary"
                      label={name}
                      size="small"
                      style={{
                        color: green[700],
                        borderColor: green[300],
                        margin: 3,
                      }}
                      variant="outlined"
                    />
                  ))}
                </>
              ),
            },
            { title: "Public", field: "public", type: "boolean" },
            { title: "Filters", field: "filterValues", hidden: true },
          ]}
          data={data}
          detailPanel={[
            {
              tooltip: "Show Filter Values",
              icon: () => <VisibilityIcon />,
              render: (rowData) => (
                <DetailSecurity
                  key={rowData.menuItemName}
                  filters={rowData?.filterValues ? rowData?.filterValues : []}
                />
              ),
            },
          ]}
          isLoading={loading}
          options={{
            exportButton: {
              csv: true,
              pdf: false,
            },
            exportAllData: true,
            exportCsv: (column, data) => {
              dispatch(downloadInfo(data)).then((response) => {
                fileDownload(response.payload.data, "Security.xlsx");
              });
            },
          }}
          title="Security"
        />
      </Grid>
    </>
  );
};
